import React, { useState } from "react";
import {
    Box,
    ListItem,
    ListItemIcon,
    ListItemText,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import useAuth from "../../context";

const LogoutButton = ({ open }) => {
    const [logoutOpen, setLogoutOpen] = useState(false);
    const auth = useAuth();

    const onLogoutClick = async () => {
        auth.logout();
        setLogoutOpen(false);
    };

    return (
        <Box sx={{ my: "8px" }}>
            <ListItem
                button
                onClick={() => setLogoutOpen(true)}
                sx={{ "&:hover": { backgroundColor: "#FFC700" } }}
            >
                <ListItemIcon>
                    <LogoutIcon />
                </ListItemIcon>
                <ListItemText
                    primary="Logout"
                    sx={{ display: open ? "block" : "none" }}
                />
            </ListItem>
            <Dialog open={logoutOpen} onClose={() => setLogoutOpen(false)}>
                <DialogTitle>Confirm Logout</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to logout?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setLogoutOpen(false)}>Cancel</Button>
                    <Button onClick={onLogoutClick} autoFocus>
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default LogoutButton;
